/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SiteNav_navigation$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type BottomBar_navigation$ref: FragmentReference;
export type BottomBar_navigation = {|
  +$fragmentRefs: SiteNav_navigation$ref,
  +$refType: BottomBar_navigation$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "BottomBar_navigation",
  "type": "Navigation",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SiteNav_navigation",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '98f7f4e1069ec45a1335dff049e67072';
module.exports = node;
